// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"menuButton--3Zzq7","moreIcon":"moreIcon--1QxJ0","menuWrapper":"menuWrapper--12a2v","menuItem":"menuItem--1K_ic","delete":"delete--2KwWb"};